/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_See_ProgressInputs */

const en_us2_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See progress`)
};

const pt_br2_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver progresso`)
};

const es_419_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver progreso`)
};

const pt_pt2_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver progresso`)
};

const fr_fr2_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la progression`)
};

const de_de2_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt ansehen`)
};

const it_it2_wrapped_see_progress = /** @type {(inputs: Wrapped_See_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi i progressi`)
};

/**
* | output |
* | --- |
* | "See progress" |
*
* @param {Wrapped_See_ProgressInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_see_progress = /** @type {((inputs?: Wrapped_See_ProgressInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_See_ProgressInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_see_progress(inputs)
	if (locale === "es-419") return es_419_wrapped_see_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_see_progress(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_see_progress(inputs)
	if (locale === "de-DE") return de_de2_wrapped_see_progress(inputs)
	if (locale === "it-IT") return it_it2_wrapped_see_progress(inputs)
	return en_us2_wrapped_see_progress(inputs)
});
export { wrapped_see_progress as "wrapped.see_progress" }